import styled from 'styled-components';
import { Button, Text, Box } from '@rsos/components/capstone/base';
import getCallStatusColor from '@rsos/utils/getCallStatusColor';

export const BaseInfoWindowWarningText = styled(Text).attrs({
  size: 'small',
})`
  color: #ea5151;
  width: 100%;
`;
export const InlineText = styled(BaseInfoWindowWarningText).attrs({
  fontWeight: 'bold',
})`
  display: inline;
`;
export const InfoWindowWarningSubtext = styled(BaseInfoWindowWarningText).attrs(
  {
    size: 'xsmall',
  },
)``;

export const InfoWindowConfirmationContainer = styled(Box).attrs({
  width: 340,
  height: 180,
  py: 3,
  pl: 3,
  pr: '14px',
  justify: 'space-between',
  align: 'space-between',
})``;

export const InfoWindowButtonContainer = styled(Box).attrs({
  pt: 1,
  width: 1,
  justify: 'space-between',
})``;

export const BaseInfoWindowConfirmationText = styled(Text).attrs({
  fontWeight: 'regular',
  pb: 2,
})`
  color: #2d2d2d;
  width: 100%;
`;

export const InfoWindowConfirmationTitle = styled(
  BaseInfoWindowConfirmationText,
).attrs({
  size: 'xlarge',
  fontWeight: 'semibold',
})``;

export const InfoWindowConfirmationText = styled(
  BaseInfoWindowConfirmationText,
).attrs({
  size: 'small',
})`
  color: #636363;
`;

export const InfoWindowCancelButton = styled(Button).attrs({
  size: 'large',
  btnType: 'tertiary',
  px: '29px',
  ml: 0,
})``;

export const InfoWindowConfirmButton = styled(Button).attrs({
  size: 'large',
  btnType: 'primary',
  px: '29px',
})``;

interface CallStatusTagProps {
  status?: string;
  isCallPopup?: boolean;
}

export const CallStatusTag = styled(Box).attrs<CallStatusTagProps>(
  ({ status, isCallPopup }) => ({
    width: 'fit-content',
    margin: isCallPopup ? '0 0 5px 0' : '4px 0 5px 0',
    padding: '2px 4px',
    backgroundColor: getCallStatusColor(status ?? '', true),
    align: 'center',
    justify: 'center',
  }),
)<CallStatusTagProps>`
  border-radius: 5px;
`;

interface CallStatusProps {
  status?: string;
}

export const CallStatus = styled(Text).attrs<CallStatusProps>(({ status }) => ({
  marginTop: 0,
  color: getCallStatusColor(status ?? '', false),
  fontWeight: 'semibold',
  ellipsis: true,
  lineHeight: 1,
  size: 'small',
  textTransform: 'uppercase',
}))<CallStatusProps>``;
